import flagRussia from '../../assets/img/language/russia.svg';
import flagUSA from '../../assets/img/language/usa.svg';

export const languageOptions = [
  { id: 'en', name: 'EN', image: flagUSA },
  { id: 'ru', name: 'RU', image: flagRussia },
];
